import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {withStyles} from "@material-ui/styles";
import {Spinner} from "../common/Spinner";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import {CardContent} from "@material-ui/core";
import PerformanceReviewTemplate from "./PerformanceReviewTemplate";
import { t } from '../../i18n';

const classes = () => ({
    card: {
        width: '100%',
    },
});

class Performance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isEditCustomerComplaints: false,
            isEditCustomerNumbers: false,
            isEditActions: false,
            complaintsButtonLabel: t('common.customize'),
            customerNumbersButtonLabel: t('common.customize'),
            actionsButtonLabel: t('common.customize'),
        };
        this.editCustomerComplaints = this.editCustomerComplaints.bind(this);
        this.editCustomerNumbers = this.editCustomerNumbers.bind(this);
        this.editActions = this.editActions.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    onChanged(customerComplaints) {
        console.log(customerComplaints);
    }

    editCustomerComplaints() {
        console.log('this.state.isEditCustomerComplaints', this.state.isEditCustomerComplaints);
        let newVal = !this.state.isEditCustomerComplaints;
        this.setState({
            isEditCustomerComplaints: newVal,
            complaintsButtonLabel: newVal ? t('common.redraw') : t('common.customize')
        });
        return false;
    }

    editCustomerNumbers() {
        let newVal = !this.state.isEditCustomerNumbers;
        this.setState({
            isEditCustomerNumbers: newVal,
            customerNumbersButtonLabel: newVal ? t('common.redraw') : t('common.customize')
        });
        return false;
    }

    editActions() {
        let newVal = !this.state.isEditActions;
        this.setState({
            isEditActions: newVal,
            actionsButtonLabel: newVal ? t('common.redraw') : t('common.customize')
        });
        return false;
    }

    render() {
        let { classes } = this.props;

        return <div>
            <div className="mui-container-fluid">
                <Route path={`/performance` }>
                    <Paper>
                        <Card className={classes.card}>
                            <CardContent>
                                <Route
                                    path={`/performance/performance-review-template`}
                                    render={() =>
                                        <PerformanceReviewTemplate currentUser={this.props.currentUser}/>
                                    }
                                />
                            </CardContent>
                        </Card>
                    </Paper>
                </Route>
            </div>
        </div>;
    }
}

export default withStyles(classes)(Performance);